import { COMMA, ENTER } from '@angular/cdk/keycodes';

export class OrderList {
	listaEscolhido: Array<string> = [];
	listaDisponivel: Array<string> = [];

	visible = true;
	selectable = true;
	removable = true;
	addOnBlur = true;
	readonly separatorKeysCodes: number[] = [ENTER, COMMA];


	constructor(listainicial: Array<string>) {
		this.listaDisponivel = listainicial;
	}


	add (op: string) {
		const index = this.listaDisponivel.indexOf(op);

		if (index >= 0) {
			this.listaDisponivel.splice(index, 1);
			this.listaEscolhido.push(op);
		}
	}


	remove (op: string): void {
		const index = this.listaEscolhido.indexOf(op);

		if (index >= 0) {
			this.listaEscolhido.splice(index, 1);
			this.listaDisponivel.push(op);
		}
	}
}
